const parseAmount = (value) => {
  const cleaned = String(value ?? "").replace(/[^0-9.]/g, "");
  const amount = Number.parseFloat(cleaned);
  return Number.isFinite(amount) ? amount : 0;
};

const hasNaira = (value) => /₦|ngn/i.test(String(value ?? ""));
const hasDollar = (value) => /\$|usd/i.test(String(value ?? ""));

export const getPaymentDetails = (cost) => {
  const raw = String(cost ?? "").trim();

  if (!raw || /free/i.test(raw)) {
    return { amount: 0, currency: "NGN", isFree: true, isValid: true };
  }

  const parts = raw.split("/").map((part) => part.trim()).filter(Boolean);

  let amount = 0;
  let currency = "NGN";

  if (parts.length > 1) {
    const nairaPart = parts.find(hasNaira);
    const dollarPart = parts.find(hasDollar);

    if (nairaPart) {
      amount = parseAmount(nairaPart);
      currency = "NGN";
    } else if (dollarPart) {
      amount = parseAmount(dollarPart);
      currency = "USD";
    } else {
      amount = parseAmount(parts[0]);
      currency = "NGN";
    }
  } else {
    amount = parseAmount(raw);
    currency = hasDollar(raw) && !hasNaira(raw) ? "USD" : "NGN";
  }

  const isFree = amount === 0;
  const isValid = Number.isFinite(amount) && amount > 0;
  return { amount, currency, isFree, isValid };
};
